import React, { useEffect, useState } from 'react';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { Alert, Breadcrumbs, Container, H1, Loader, Tabs } from '@itds/elements/index.js';

import General from '@carrier/pages/vendors/General';
import Relationships from '@carrier/pages/vendors/Relationships';

import { Api } from '@carrier/utils/Api';

const Show = () => {
  const params = useParams();
  const navigate = useNavigate();

  const [vendor, setVendor] = useState({});
  const [loading, setLoading] = useState(false);
  const [error_message, setErrorMessage] = useState(null);
  const [success_message, setSuccessMessage] = useState(null);

  useEffect(() => {
    loadVendor();
  }, []);

  const loadVendor = action => {
    setLoading(true);

    setTimeout(() => {
      setSuccessMessage(null);
      setErrorMessage(null);
    }, 2000);

    Api.loadVendor(params.id)
      .then(({ data }) => {
        setVendor(data);
        setLoading(false);
        if (action === 'save') {
          setSuccessMessage('Vendor Successfully Saved');
        }
      })
      .catch(() => {
        if (action === 'save') {
          setErrorMessage('Unable to save vendor at this time');
        }
      });
  };

  const props = {
    loadVendor,
    vendor
  };

  return loading ? (
    <Loader />
  ) : (
    <Container>
      <H1>{vendor.name}</H1>
      <Breadcrumbs
        crumbs={[{ label: 'Vendors', onClick: navigate.bind(null, '/vendors') }]}
        current={vendor.name}
      />

      {success_message ? <Alert type='success'>{success_message}</Alert> : null}
      {error_message ? <Alert type='error'>{error_message}</Alert> : null}
      <Tabs
        tabs={[
          {
            isActive: window.location.hash === `#/vendors/${vendor.id}`,
            label: 'General',
            onClick: navigate.bind(null, '')
          },
          {
            isActive: window.location.hash.includes('relationships'),
            label: 'Carrier Relationships',
            to: 'relationships'
          }
        ]}
      />

      <div style={{ padding: '40px 20px' }}>
        <Routes>
          <Route element={<General {...props} />} index={true} />
          <Route element={<Relationships {...props} />} path='relationships' />
        </Routes>
      </div>
    </Container>
  );
};

export default Show;
